import { parsedTakeaways } from '@features/lci-report/domain/key-takeaways';
import { TextProps } from '@features/powerpoint';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

export const annotationsTextContent = (
  keyTakeaways: string[],
  recommendations?: string[]
): TextProps[] => {
  const keyTakeawaysText: TextProps[] = [
    {
      text: parsedTakeaways(keyTakeaways),
      options: {
        h: 0.92,
        w: 12,
        x: 0.66,
        y: 5.69,
        valign: 'top',
        paraSpaceAfter: 4,
        fontSize: 8,
      },
    },
  ];

  const recommendationText: TextProps[] =
    recommendations && recommendations.length > 0
      ? [
          {
            text: 'INMARKET RECOMMENDS',
            options: {
              color: unifiedPlatformColorPalette.inmarketGreen,
              fontSize: 12,
              bold: true,
              h: 0.4,
              w: 3.4,
              x: 0.66,
              y: 6.29,
            },
          },
          {
            text: recommendations.at(0) ?? '',
            options: {
              h: 0.84,
              w: 12,
              x: 0.66,
              y: 6.61,
              valign: 'top',
              paraSpaceAfter: 12,
              fontSize: 10,
            },
          },
        ]
      : [];

  return [...keyTakeawaysText, ...recommendationText];
};
